module.exports = __webpack_public_path__ + "static/media/dmk-eta-container.6eaaab45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dmk-eta-container.png
// module id = 96
// module chunks = 0